module.exports = __webpack_public_path__ + "static/media/25-2.ead828f6.mp3";